import React from 'react';
import { ArrowRight, Globe2 } from 'lucide-react';

const Decarbonizing = () => {
  return (
    <section id="discover" className="relative py-24 bg-white overflow-hidden">
      {/* Subtle green background pattern */}
      <div className="absolute -right-40 top-1/4 w-[500px] h-[500px] rounded-full bg-[#8ec045]/5 blur-3xl" />

      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Globe illustration */}
          <div className="relative flex justify-center">
            <div className="relative w-[380px] h-[380px] md:w-[440px] md:h-[440px]">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#e8f4d4] via-[#c5e397] to-[#8ec045] shadow-2xl" />
              <div className="absolute inset-8 rounded-full bg-gradient-to-br from-[#7cad38] to-[#5a8c26] flex items-center justify-center overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxyZW5ld2FibGUlMjBlbmVyZ3l8ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85"
                  alt="Earth"
                  className="w-full h-full object-cover opacity-60 mix-blend-overlay"
                />
                <Globe2 className="absolute w-40 h-40 text-white/80" strokeWidth={0.8} />
              </div>
              {/* Orbit ring */}
              <div className="absolute inset-[-30px] rounded-full border border-dashed border-[#8ec045]/40 animate-[spin_60s_linear_infinite]" />
              <div className="absolute inset-[-60px] rounded-full border border-[#8ec045]/20 animate-[spin_90s_linear_infinite_reverse]" />
              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-white shadow-xl rounded-lg px-4 py-3 border-t-2 border-[#8ec045]">
                <div className="text-[10px] tracking-widest text-gray-500">CARBON</div>
                <div className="text-lg font-bold text-[#5a8c26]">Neutral</div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="inline-block text-[#8ec045] text-xs font-bold tracking-[4px] mb-4">
              OUR VISION
            </span>
            <h2
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1a1a1a] leading-[1.1] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Decarbonizing<br />
              <span className="text-[#8ec045]">the World</span>
            </h2>
            <p className="text-[15px] md:text-base text-[#555] leading-[1.9] mb-8 max-w-xl">
              Raynav Green is committed to creating a greener and brighter future by
              leading a charge towards a carbon-neutral world. We provide a comprehensive
              range of efficient and integrated sustainable green energy solutions by
              fostering innovative thinking and harnessing the power of renewable energy
              assets to benefit the planet and its people.
            </p>
            <a
              href="#discover"
              className="inline-flex items-center gap-2 text-[#8ec045] font-bold text-[13px] tracking-wider hover:gap-4 transition-all group"
            >
              READ MORE
              <span className="w-9 h-9 rounded-full border-2 border-[#8ec045] flex items-center justify-center group-hover:bg-[#8ec045] transition-colors">
                <ArrowRight className="w-4 h-4 group-hover:text-white transition-colors" />
              </span>
            </a>

            {/* Stat card */}
            <div className="mt-12 pl-6 border-l-4 border-[#8ec045]">
              <div className="text-[13px] font-semibold text-[#333]">Clean Energy Delivered to</div>
              <div className="text-lg text-[#555] mt-1">Indian Households for an entire year</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Decarbonizing;
